module.exports = __webpack_public_path__ + "media/images/athletes/1418-a0be7a58c6b890cd44bff0eb12f90f70.png";